import {TheRaveParsedData} from "./TheRaveParsedData";
import {ITheRaveInitData, ISymbolValues} from "./ITheRaveData";
import {TheRaveDataParser} from "./TheRaveDataParser";
import {Helper} from "../../debug/utils/Helper";
import {MathHelper} from "../../debug/utils/MathHelper";

export class TheRaveParsedInitData extends TheRaveParsedData {

    public readonly betLines:number[][];
    public readonly symbolValues:ISymbolValues;
    public readonly isRestoreState:boolean;
    public readonly totalWays:number;
    public readonly xWaysSizeEachReel:number[];
    public readonly mysterySymbolRevealed:string;
    public readonly reelSizes:number[];
    public readonly enhancersNum:number;
    public readonly scattersNum:number;

    constructor(rawData: ITheRaveInitData, parser: TheRaveDataParser) {
        super(rawData, parser);

        this.betLines = rawData.betLines;
        this.symbolValues = rawData.symbolValues;
        this.isRestoreState = rawData.isRestoreState;
        this.totalWays = this.getTotalWays(rawData);//rawData.totalWays;
        this.xWaysSizeEachReel = rawData.xWaysSizeEachReel;
        this.mysterySymbolRevealed = rawData.mysterySymbolRevealed;
        this.reelSizes = [3, 3, 3, 3, 3];
        this.scattersNum = (rawData.freespinTriggeredThisSpin?this.getScattersNum(rawData):0);
        this.enhancersNum =  Math.max(rawData.scatterEnhancers.length, this.scattersNum);
    }

    private getScattersNum(rawData: ITheRaveInitData):number{
        return 0;

        let scattersNum:number = 0;
        rawData.scatterPositions.forEach((pos:number)=>{
            scattersNum+=(pos>-1?1:0);
        });
        return scattersNum;
    }

    private getTotalWays(rawData: ITheRaveInitData):number{
        const ways:number[] = [];
        (rawData.symbolSizes.forEach((a:number[]) => {
            ways.push(this.sum(a));
        }));
        //console.log(ways)
        const totalWays:number = ways.reduce((a,b)=>a*b);

        return (totalWays>0?totalWays:rawData.totalWays);
    }

    private sum(arr:number[]):number{
        return arr.reduce((a, b) => a + (b===0?1:b), 0);
    }

}